<div class="tt-comment-card-comment">
  <div class="tt-comment-card-comment_header">
    <div class="tt-comment-card-comment_header-info">
      <div class="tt-comment-card-comment_avatar">
        <tt-avatar [placeholder]="createdBy() | initials" />
      </div>
      <div class="tt-comment-card-comment_user-info">
        <div class="tt-comment-card-comment_username">{{ createdBy() | name }}</div>

        @if (comment().createdAt || comment().updatedAt) {
          <div class="tt-comment-card-comment_timestamp">
            {{ comment().createdAt | timeStampUpdated }}
            @if (comment().updatedAt) {
              ({{ 'Comments.Edited' | transloco }})
            }
          </div>
        }
      </div>
    </div>
    <div class="tt-comment-card-comment_header-right">
      @if (!!comment().createdAt) {
        @if (comment().resolved) {
          <button
            class="tt-comment-card-comment_header-resolved"
            ttButton
            [size]="'icon'"
            [ttMenuTriggerFor]="resolveMenu"
            [ttTooltip]="'Comments.Resolved' | transloco"
            [variant]="'transparent'">
            <mat-icon [icon]="'circle-check-big'" [iconSize]="14" />
          </button>
        }

        @if (!readonly()) {
          <div class="tt-comment-card-comment_header-actions">
            <button ttButton [size]="'icon'" [ttMenuTriggerFor]="menu" [variant]="'transparent'">
              <mat-icon [icon]="'ellipsis-vertical'" [iconSize]="16" />
            </button>
          </div>
        }
      }
    </div>
  </div>
  @if (path()) {
    <div class="tt-comment-card-comment_path">{{ path() }}</div>
  }
  <div class="tt-comment-card-comment_comment">
    <div class="tt-comment-card-comment_comment-text">
      @if (editMode()) {
        <common-rich-text-editor
          class="tt-comment-card-comment_comment-text-editor"
          [focusOnInit]="true"
          [placeholder]="'Comments.EmptyCommentPlaceholder' | transloco"
          [toolbarType]="'basic'"
          [ttAutofocus]="true"
          [(editorContent)]="text" />

        <div class="tt-comment-card-comment_comment-text-actions">
          <button ttButton [variant]="'secondary'" (click)="handleCancelEditComment()">{{ 'Cancel' | transloco }}</button>
          <button ttButton [disabled]="!text()" [variant]="'primary'" (click)="handleEditComment()">{{ 'Save' | transloco }}</button>
        </div>
      } @else {
        <common-rich-text-view [content]="text()" />
      }
    </div>
  </div>
</div>

<tt-menu #menu>
  @if (!editMode()) {
    <button ttMenuItem (click)="editMode.set(true)">
      <mat-icon [icon]="'pencil'" [iconSize]="16" />
      {{ 'Edit' | transloco }}
    </button>
  }

  <button ttMenuItem (click)="deleteComment.emit(true)">
    <mat-icon [icon]="'trash'" [iconSize]="16" />
    {{ 'Delete' | transloco }}
  </button>
</tt-menu>

<tt-menu #resolveMenu>
  <button ttMenuItem (click)="resolveComment.emit(true)">
    <mat-icon [icon]="'circle-off'" [iconSize]="16" />
    {{ 'Comments.Unresolve' | transloco }}
  </button>
</tt-menu>
